<template>
  <vf-footer>
    <template #brightedge v-if="$feature.tempEnableBrightedge">
      <div class="be-ix-link-block">
        <!-- Link Block Targeting Div -->
      </div>
    </template>
  </vf-footer>
</template>

<script lang="ts" setup>
import VfFooter from '#brand/components/vf/footer/Footer.vue'
</script>
